export default __webpack_public_path__ + "2f6f1f6753d430190cb38411a9112f08.js";